import { Action, ActionCreator } from 'redux';

export * from './authMember/authMemberActions';
export * from './authentication/authenticationActions';
export * from './session/sessionActions';
export { updateFeatureFlag } from './features';
export * from './organization/organizationActions';
export * from './organizationSubscriptionStatus/organizationSubscriptionStatusActions';

export interface IStoreLogoutAction extends Action {
  type: 'LOGOUT';
}

export const logoutAction: ActionCreator<IStoreLogoutAction> = () => ({
  type: 'LOGOUT',
});
